$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(document).ready(function(){
  if ($('body').hasClass('rtl')) {
    // Display an alert
    var added = "تمت الإضافة!"
    var addToCart = "أضف إلى السلة"
  }else{
    var added = "Added"
    var addToCart = "Add To Cart"
  }
	$(document).on('click', '.ab-addtocart',function() {
      	var $this = $(this)
      	var dot = ''
      	var setIntervalDot = setInterval(function(){
          	console.log()
            if (dot.length === 3) {
              dot = '.'
            } else {
              dot += '.'
            }
      		$this.find('.indicator').text(dot)
      	}, 500)
        
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: 1,
            id: $(this).data('variant-id')
          },
          dataType: 'json',
          success: function (data) {
            clearInterval(setIntervalDot)
//       		$this.find('.indicator').html('&check;')
              $this.find('.indicator').html('')
            $this.find('.text').html(added)
            setTimeout(function(){
            	$this.find('.text').html(addToCart)
            }, 2000)
            $.ajax({
              type: 'GET',
              dataType: 'json',
              url: '/cart.json',
              success: function(cart){
      //           console.log(cart)
                $('.site-header__cart-count span[data-cart-count]').html(cart.items.length);
                if($('#bublecount').text() != 0 ){
                	$(".site-header__cart-count").removeClass("hide");
                }
                else{
                	$(".site-header__cart-count").addClass("hide");
                }
              }
            });
          }
        });
      })
    
    $(document).on('click', '.addtocartnew .ab-quickview', function(){
      if (!$('.boost-pfs-modal-backdrop').length) {
        $('body').append(`
			<div class="boost-pfs-modal-backdrop">
				<div class="boost-pfs-modal-container">
					<div class="boost-pfs-modal-content"></div>
				</div>
			</div>`)
      }
      
      $('.boost-pfs-modal-backdrop').show(0)
      
      console.log($(this).data('href'))
      
      $.ajax({
              type: 'GET',
              url: $(this).data('href'),
              success: function(html){
                $('.boost-pfs-modal-content').html(html)
      			$('.boost-pfs-modal-container').show(0)
              }
            });
      
      
    })
    
    if ($('.product-single__meta .price--on-sale .price__badge--sale').css('display') == 'flex') {
    	$('.product-single__meta .price--on-sale .price__badge--sale').parents('.price__badges').appendTo('.product-single__media-wrapper')
    }
    
  	$(document).on('click', '.swym-button.swym-add-to-wishlist-view-product:not(.swym-loaded)', function(){
      var $this = $(this)
      var handle = $this.data('handle')
      $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/products/' + handle + '.json',
        success: function(res){
          if (res.product) {
//           	console.log(res.product)
            var product = res.product
            var variant = null
            
            if (product.variants.length) {
            	variant = product.variants[0]
            }
            
            var productData = {
              "et": SwymTracker.EventTypes.addToWishList,
              "dt": product.title, // product title 
              "du": window.location.origin + '/products/' + product.handle, // product full url 
              "empi": variant ? variant.id : 0, // variant id 
              "epi": product.id, // product id 
              "pr": variant.price, // price 
              "iu": product.images[0].src // image url
            }
            
            var vs = {}
            vs[variant.id] = variant.id
            
            productData = {
              "empi": product.id,
              "epi": variant.id,
              "dt": product.title,
              "du": window.location.origin + '/products/' + product.handle,
              "ct": product.type,
              "pr": product.price,
              "stk": variant.inventory_quantity,
              "iu": product.images[0].src,
              "variants":[vs],
              "_cv": true,
              "vi": variant.id
            }
            
            
//             console.log(productData)
            _swat.addToWishList(productData, function(){
            	$this.addClass('disabled swym-added swym-adding')
            })
            
          }
        }
      });
      

    })
  	
    
});


(function (window) {
    var last = +new Date();
    var delay = 100; // default delay

    // Manage event queue
    var stack = [];

    function callback() {
        var now = +new Date();
        if (now - last > delay) {
            for (var i = 0; i < stack.length; i++) {
                stack[i]();
            }
            last = now;
        }
    }

    // Public interface
    var onDomChange = function (fn, newdelay) {
        if (newdelay) delay = newdelay;
        stack.push(fn);
    };

    // Naive approach for compatibility
    function naive() {

        var last = document.getElementsByTagName('*');
        var lastlen = last.length;
        var timer = setTimeout(function check() {

            // get current state of the document
            var current = document.getElementsByTagName('*');
            var len = current.length;

            // if the length is different
            // it's fairly obvious
            if (len != lastlen) {
                // just make sure the loop finishes early
                last = [];
            }

            // go check every element in order
            for (var i = 0; i < len; i++) {
                if (current[i] !== last[i]) {
                    callback();
                    last = current;
                    lastlen = len;
                    break;
                }
            }

            // over, and over, and over again
            setTimeout(check, delay);

        }, delay);
    }

    //
    //  Check for mutation events support
    //

    var support = {};

    var el = document.documentElement;
    var remain = 3;

    // callback for the tests
    function decide() {
        if (support.DOMNodeInserted) {
            window.addEventListener("DOMContentLoaded", function () {
                if (support.DOMSubtreeModified) { // for FF 3+, Chrome
                    el.addEventListener('DOMSubtreeModified', callback, false);
                } else { // for FF 2, Safari, Opera 9.6+
                    el.addEventListener('DOMNodeInserted', callback, false);
                    el.addEventListener('DOMNodeRemoved', callback, false);
                }
            }, false);
        } else if (document.onpropertychange) { // for IE 5.5+
            document.onpropertychange = callback;
        } else { // fallback
            naive();
        }
    }

    // checks a particular event
    function test(event) {
        el.addEventListener(event, function fn() {
            support[event] = true;
            el.removeEventListener(event, fn, false);
            if (--remain === 0) decide();
        }, false);
    }

    // attach test events
    if (window.addEventListener) {
        test('DOMSubtreeModified');
        test('DOMNodeInserted');
        test('DOMNodeRemoved');
    } else {
        decide();
    }

    // do the dummy test
    var dummy = document.createElement("div");
    el.appendChild(dummy);
    el.removeChild(dummy);

    // expose
    window.onDomChange = onDomChange;
})(window);


onDomChange(function(){ 
  
  // Execute wishlist after xhr
  var arr = document.querySelectorAll('script.swym-product-view-snippet:not(.attached)')
  for (var n = 0; n < arr.length; n++) {
    arr[n].classList.add('attached')
    eval(arr[n].innerHTML)
  }
}); 


function wishlistFunctions() {
  window._swat.fetch(function(products){
    $('.header-wishlist .count').html(products.length)
    $('.header-wishlist .count').css('display', products.length ? 'flex' : 'none')
    
    $('.swym-button.swym-removing').each(function(){
    	$(this).removeClass('swym-added swym-adding swym-removing disabled')
    })
  })
  
  setTimeout(wishlistFunctions, 1500)
}

if(!window._swat){
 if(!window.SwymCallbacks){
   window.SwymCallbacks = [];
 }
 	window.SwymCallbacks.push(wishlistFunctions);
} else {
  wishlistFunctions();
}